// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tab_tab__DfYjk Button {
  margin: 0;
  min-width: 205px;
  font-size: 16px;
}
.Tab_tab__DfYjk Button p {
  margin: 0;
  white-space: nowrap;
}

.Tab_content__k2yS7 {
  min-width: 100px;
}
.Tab_content__k2yS7 .Tab_secondary__yJRc0.Tab_active__-gFxf {
  background-color: #1f1f1f;
  color: #ffffff;
}

@media (min-width: 1360px) {
  .Tab_tab__DfYjk Button {
    min-width: 160px;
  }
}
@media (min-width: 1800px) {
  .Tab_tab__DfYjk Button {
    min-width: 280px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Tabs/Tab/Tab.module.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAIE;EACE,SAAA;EACA,gBAAA;EACA,eCLK;ADET;AAKI;EACE,SAAA;EACA,mBAAA;AAHN;;AAQA;EACE,gBAAA;AALF;AAOE;EACE,yBEfQ;EFgBR,cEZI;AFOR;;AASA;EAEI;IACE,gBAAA;EAPJ;AACF;AAWA;EAEI;IACE,gBAAA;EAVJ;AACF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.tab {\n  Button {\n    margin: 0;\n    min-width: 205px;\n    font-size: typography.$body-l;\n\n    p {\n      margin: 0;\n      white-space: nowrap;\n    }\n  }\n}\n\n.content {\n  min-width: 100px;\n\n  .secondary.active {\n    background-color: colors.$secondary;\n    color: colors.$white;\n  }\n}\n\n@media (min-width: 1360px) {\n  .tab {\n    Button {\n      min-width: 160px;\n    }\n  }\n}\n\n@media (min-width: 1800px) {\n  .tab {\n    Button {\n      min-width: 280px;\n    }\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab": `Tab_tab__DfYjk`,
	"content": `Tab_content__k2yS7`,
	"secondary": `Tab_secondary__yJRc0`,
	"active": `Tab_active__-gFxf`
};
export default ___CSS_LOADER_EXPORT___;
